





















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storePemeriksaanFisikRalan } from "@/store/modules/pemeriksaanfisikralan";
import { storeNyeri } from "@/store/modules/nyeri";
// import PemeriksaanFisik from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/PemeriksaanFisik.vue";
// import DataPemeriksaanFisikRalan from "@/services/DataPemeriksaanFisikRalan";
import DataNyeri from "@/services/DataNyeri";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import TandaVital from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/TandaVital.vue";
import Antropometri from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/Antropometri.vue";
import Nyeri from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/Nyeri.vue";
import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import RiwayatNyeri from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/RiwayatNyeri.vue";

@Component({
  components: {
    // PemeriksaanFisik
    TandaVital,
    Antropometri,
    Nyeri,
    PerawatAutoComplete,
    RiwayatNyeri
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPemeriksaanFisik extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  sess_login = userModule.user;
  getparam = {
    unit_id: this.sess_login.unit_id,
    reg: this.register
  };
  // tanda_vital = {
  //   sistole: null,
  //   diastole: null,
  //   frekuensi_nadi: "",
  //   frekuensi_nafas: "",
  //   suhu_badan: "",
  //   saturasi_oksigen: "",
  //   keadaan_umum: "",
  //   kesadaran: "",
  // };
  // antropometri = {
  //   berat_badan: "",
  //   tinggi_badan: "",
  //   imt: "",
  //   lingkar_kepala: "",
  //   lla: "",
  // };
  nyeri = {
    skala: 0,
    lokasi: "",
    intensitas: "",
    durasi: "",
    frekuensi: "",
    pencetus: "",
    kualitas: "",
    pola_serangan: "",
    penyebab_hilang: "",
    jenis: "0",
    user: {
      id: "",
      nama: ""
    }
  };
  loadingSimpan = false;
  get sessLogin() {
    return userModule.user;
  }
  get statePemeriksaanFisikRalan() {
    return storePemeriksaanFisikRalan.pemeriksaanfisikralan;
  }
  get stateNyeri() {
    return storeNyeri.detailnyeri[0];
  }
  get stateNyeriByRm() {
    return storeNyeri.nyeri;
  }

  // setTandaVital(val) {
  //   // console.log("setTandaVital", val);
  //   this.tanda_vital = val;
  // }
  // setAntropometri(val) {
  //   // console.log("setAntropometri ", val);

  //   this.antropometri = val;
  // }
  setNyeri(val) {
    this.nyeri = val;
  }
  setPerawat(val) {
    this.nyeri["user"] = val;
    console.log("perawat", val);
  }
  @Watch("stateNyeri")
  changePemeriksaanFisikRalan(val) {
    // if (val.tanda_vital == null) {
    //   this.tanda_vital = {
    //     sistole: null,
    //     diastole: null,
    //     frekuensi_nadi: "",
    //     frekuensi_nafas: "",
    //     suhu_badan: "",
    //     saturasi_oksigen: "",
    //     keadaan_umum: "",
    //     kesadaran: "",
    //   };
    // } else {
    //   this.tanda_vital = val.tanda_vital;
    // }
    // if (val.antropometri == null) {
    //   this.antropometri = {
    //     berat_badan: "",
    //     tinggi_badan: "",
    //     imt: "",
    //     lingkar_kepala: "",
    //     lla: "",
    //   };
    // } else {
    //   this.antropometri = val.antropometri;
    // }
    console.log("statenyeri", val);

    if (val == null) {
      this.nyeri = {
        skala: 0,
        lokasi: "",
        intensitas: "",
        durasi: "",
        frekuensi: "",
        pencetus: "",
        kualitas: "",
        pola_serangan: "",
        penyebab_hilang: "",
        jenis: "0",
        user: { id: "", nama: "" }
      };
    } else {
      this.nyeri = {
        skala: val.skala,
        lokasi: val.lokasi,
        intensitas: val.intensitas,
        durasi: val.durasi,
        frekuensi: val.frekuensi,
        pencetus: val.pencetus,
        kualitas: val.kualitas,
        pola_serangan: val.pola_serangan,
        penyebab_hilang: val.penyebab_hilang,
        jenis: val.jenis,
        user: val.user
      };
    }
  }
  simpan() {
    if (this.readOnly) return;
    this.loadingSimpan = true;
    const getUnitReg = {
      unit_id: this.sessLogin.unit_id,
      reg: this.register
    };
    let dtNyeri = {};
    if (this.nyeri.skala == null || this.nyeri.skala == 0) {
      dtNyeri = {
        // id: this.nyeri["id"],
        skala: 0,
        lokasi: "",
        intensitas: null,
        durasi: null,
        frekuensi: null,
        pencetus: "",
        kualitas: "",
        pola_serangan: "",
        penyebab_hilang: "",
        jenis: "0",
        user: this.nyeri.user
      };
    } else {
      dtNyeri = {
        // id: this.nyeri["id"],
        skala: this.nyeri.skala,
        lokasi: this.nyeri.lokasi,
        intensitas: this.nyeri.intensitas,
        durasi: this.nyeri.durasi,
        frekuensi: this.nyeri.frekuensi,
        pencetus: this.nyeri.pencetus,
        kualitas: this.nyeri.kualitas,
        pola_serangan: this.nyeri.pola_serangan,
        penyebab_hilang: this.nyeri.penyebab_hilang,
        jenis: this.nyeri.jenis,
        user: this.nyeri.user
      };
    }
    const param = {
      nyeri: dtNyeri
    };
    if (this.stateNyeri != undefined) {
      const dt = DataNyeri.editDataNyeri(
        this.stateNyeri.id,
        this.register,
        this.sess_login.unit_id,
        this.rm,
        param
      );
      dt.then(dt => {
        appModule.setLoading(false);
        if (dt["status"] != 1) {
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          appModule.NoticeDelay("Berhasil Update Asesmen Nyeri");
          storeNyeri.actNyeriByReg(getUnitReg);
          storeNyeri.actNyeriByRm(this.rm);
        }
      })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.loadingSimpan = false));
    } else {
      const dt = DataNyeri.saveDataNyeri(
        this.register,
        this.sess_login.unit_id,
        this.rm,
        param
      );
      dt.then(dt => {
        if (dt["status"] != 1) {
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          appModule.NoticeDelay("Berhasil Simpan Asesmen Nyeri");
          // storePemeriksaanFisikRalan.actPemeriksaanFisikRalan(this.getparam);
          storeNyeri.actNyeriByReg(getUnitReg);
          storeNyeri.actNyeriByRm(this.rm);
        }
      })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.loadingSimpan = false));
    }
  }
}
